import { render, staticRenderFns } from "./AssistantCatHomeMenuPanel.vue?vue&type=template&id=63afb474&scoped=true"
import script from "./AssistantCatHomeMenuPanel.vue?vue&type=script&lang=ts"
export * from "./AssistantCatHomeMenuPanel.vue?vue&type=script&lang=ts"
import style0 from "./AssistantCatHomeMenuPanel.vue?vue&type=style&index=0&id=63afb474&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63afb474",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/nola-frontend/nola-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('63afb474')) {
      api.createRecord('63afb474', component.options)
    } else {
      api.reload('63afb474', component.options)
    }
    module.hot.accept("./AssistantCatHomeMenuPanel.vue?vue&type=template&id=63afb474&scoped=true", function () {
      api.rerender('63afb474', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/organisms/assistantCatHome/AssistantCatHomeMenuPanel.vue"
export default component.exports